<div>
  <div class="vehicle-wrapper">
    <div class="top-header">
      <h3>Select Period</h3>
      <p>Results between the selected dates will be displayed</p>
    </div>
   
    <form [formGroup]="genarateReportFrom" (ngSubmit)="generateReport(currentPage, recordsPerPage)">
      <!-- <div class="card-top card-head">
        <h4>Select Period</h4>
        <p>Results between the selected dates will be displayed</p>
      </div> -->
      <div class="date-form">
        <div class="form-group">
          <label for="fromDate">Select from Date <small>*</small></label>
          <!-- <input type="date" formControlName="fromDate" required > -->
           <p-datepicker formControlName="fromDate" 
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            inputId="fromDate"
                            [showOnFocus]="true" 
                            [showButtonBar]="true" 
                            [maxDate]="today"
                            [readonlyInput]="true"
                            
                            required />
          <div class="error" *ngIf="genarateReportFrom.get('fromDate')?.invalid && genarateReportFrom.get('fromDate')?.touched">
            <small *ngIf="genarateReportFrom.get('fromDate')?.errors?.['required']">From date is required</small>
          </div>
        </div>
        <div class="form-group">
          <label for="toDate">Select to Date <small>*</small></label>
          <!-- <input type="date" formControlName="toDate" required> -->
           <p-datepicker formControlName="toDate" 
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            inputId="toDate"
                            [showOnFocus]="true" 
                            [showButtonBar]="true" 
                            [maxDate]="today"
                            [readonlyInput]="true"
                            required />
          <div class="error" *ngIf="genarateReportFrom.get('toDate')?.invalid && genarateReportFrom.get('toDate')?.touched">
            <small *ngIf="genarateReportFrom.get('toDate')?.errors?.['required']">To date is required</small>
          </div>
        </div>
      </div>
      <div class="ctr-btn">
        <button type="submit"
        class="btn-generate btn-action"
        
        >
          <fa-icon [icon]="['fas', 'square-poll-vertical']" class="fa-solid"></fa-icon>
          GENERATE
        </button>
      </div>
    </form>
  </div>
</div>

<div class="show-table-div" *ngIf="noRecords">
  <div class="error-msg">
      <p>
        <fa-icon [icon]="['fas', 'circle-exclamation']" class="fa-thin"></fa-icon>
        No records found in the given date range
      </p>
    </div>
</div>
<div class="show-table-div" *ngIf="showTable">
  <div class="top-header">
    <h3>Vehicle Activity</h3>
    <p>Vehicle details as on {{genarateReportFrom.value.fromDate | date: "dd-MM-yyyy"}} to {{genarateReportFrom.value.toDate | date: "dd-MM-yyyy"}}</p>
  </div>
  <div class="table-container">
    <!-- <div class="card-top card-head">
      <h4>Vehicle Activity</h4>
      <p>Vehicle details as on {{genarateReportFrom.value.fromDate | date: "dd-MM-yyyy"}} to {{genarateReportFrom.value.toDate | date: "dd-MM-yyyy"}}</p>
    </div> -->
    <div class="tab-head">
      <div class="search-bar">
          <label>Search</label>
          <app-generic-search
                  [apiUrl]="'generate-report/search_suggestion'"
                  [resultsApiUrl]="'generate-report/'"
                  [method]="'POST'"
                  [searchParamName]="'search_text'"
                  [extraBody]="{ camera_esn: camera_esn, 'from_date': rawData.from_date, 'to_date': rawData.to_date }"
                  [pageSize]="10"
                  [minChars]="2"
                  (resultsFetched)="onResults($event)">
          </app-generic-search>
      </div>
      <div class="filters table-filters" [formGroup]="genarateReportFrom">
        <div class="filter">
          <label>Status</label>
          <select formControlName="dashboardFilter" (change)="onStatusChange()">
            <option value="">All</option>
            <option value="Matched">Matched</option>
            <option value="Unmatched">Unmatched</option>
          </select>
        </div>
        <div class="filter">
          <label>Direction</label>
          <select formControlName="directionFilter" (change)="onDirectionChange()">
            <option value="">All</option>
            <option value="Entry">Entry</option>
            <option value="Exit">Exit</option>
          </select>
        </div>
      </div>
        <button type="button" (click)="exportToExcel()" class="export-button">
        <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
        EXPORT EXCEL
      </button>
    </div>
    <div class="responsive-table-wrapper">
      <table>
        <thead class="table-name">
          <tr>
            <th>S.No</th>
            <th>Match</th>
              <th (click)="sortData('vehicle_number')" (mouseenter)="hoveredColumn = 'vehicle_number'"
                  (mouseleave)="hoveredColumn = ''">
                  Vehicle Number
                  <span *ngIf="sortDirection === 'asc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'vehicle_number' || sortColumn === 'vehicle_number'">
                <fa-icon [icon]="['fas', 'arrow-up']" [ngClass]="{'active': sortColumn === 'vehicle_number'}"></fa-icon>
              </span>
                  <span *ngIf="sortDirection === 'desc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'vehicle_number' || sortColumn === 'vehicle_number'">
                <fa-icon [icon]="['fas', 'arrow-down']"
                         [ngClass]="{'active': sortColumn === 'vehicle_number'}"></fa-icon>
              </span>
              </th>
              <th (click)="sortData('created_at')" (mouseenter)="hoveredColumn = 'date'"
                  (mouseleave)="hoveredColumn = ''">
                  Date
                  <span *ngIf="sortDirection === 'asc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'date' || sortColumn === 'created_at'">
                <fa-icon [icon]="['fas', 'arrow-up']" [ngClass]="{'active': sortColumn === 'created_at'}"></fa-icon>
              </span>
                  <span *ngIf="sortDirection === 'desc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'date' || sortColumn === 'created_at'">
                <fa-icon [icon]="['fas', 'arrow-down']" [ngClass]="{'active': sortColumn === 'created_at'}"></fa-icon>
              </span>
              </th>
              <th (click)="sortData('created_at')" (mouseenter)="hoveredColumn = 'time'"
                  (mouseleave)="hoveredColumn = ''">
                  Time
                  <span *ngIf="sortDirection === 'asc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'time' || sortColumn === 'created_at'">
                <fa-icon [icon]="['fas', 'arrow-up']" [ngClass]="{'active': sortColumn === 'created_at'}"></fa-icon>
              </span>
                  <span *ngIf="sortDirection === 'desc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'time' || sortColumn === 'created_at'">
                <fa-icon [icon]="['fas', 'arrow-down']" [ngClass]="{'active': sortColumn === 'created_at'}"></fa-icon>
              </span>
              </th>
              <th (click)="sortData('direction')" (mouseenter)="hoveredColumn = 'direction'"
                  (mouseleave)="hoveredColumn = ''">
                  Direction
                  <span *ngIf="sortDirection === 'asc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'direction' || sortColumn === 'direction'">
                <fa-icon [icon]="['fas', 'arrow-up']" [ngClass]="{'active': sortColumn === 'direction'}"></fa-icon>
              </span>
                  <span *ngIf="sortDirection === 'desc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'direction' || sortColumn === 'direction'">
                <fa-icon [icon]="['fas', 'arrow-down']" [ngClass]="{'active': sortColumn === 'direction'}"></fa-icon>
              </span>
              </th>
              <th (click)="sortData('camera_esn')" (mouseenter)="hoveredColumn = 'camera_esn'"
                  (mouseleave)="hoveredColumn = ''">
                  Camera
                  <span *ngIf="sortDirection === 'asc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'camera_esn' || sortColumn === 'camera_esn'">
                <fa-icon [icon]="['fas', 'arrow-up']" [ngClass]="{'active': sortColumn === 'camera_esn'}"></fa-icon>
              </span>
                  <span *ngIf="sortDirection === 'desc'" class="sort-icons"
                        [class.visible]="hoveredColumn === 'camera_esn' || sortColumn === 'camera_esn'">
                <fa-icon [icon]="['fas', 'arrow-down']" [ngClass]="{'active': sortColumn === 'camera_esn'}"></fa-icon>
              </span>
              </th>
            <th>Vehicle Image</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of reportData; let i = index">
            <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> <!-- 10 -> pagesize -->
            <td>
              <span [ngClass]="record.is_match ? 'green-circle' : 'red-circle'" ></span>
            </td>
              <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
            <td>{{ record.created_at | date:"dd-MM-yyyy" }}</td>
            <td>{{ record.created_at | date:"hh:mm a" }}</td>
            <td>{{ record.direction }}</td>
            <td>{{ displayCameraEsn(record) }}</td>
            <td>
              <button (click)="viewImage(record.vehicle_image_url, record.direction )">
                <fa-icon [icon]="['fas', 'eye']" class="fa-light"></fa-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    
      <div class="footer">
        <div class="total-records">Total Records: {{ totalRecords }}</div>
        <div class="pagination-controls">
          <label for="recordsPerPage">Records per page </label>
          <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()" >
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
          </select>
          <span>{{ currentPage }} / {{ totalPages }}</span>
          <button (click)="previous()"[disabled]="!previousPage"  class="change-page" title="Previous page">
            <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
          </button>
          <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
            <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add this modal HTML below your table -->
<app-image-viewer
  [images]="selectedImages"
  [show]="showModal"
  [closeModal]="closeModal"
></app-image-viewer>
